export default class RequestStatusType {
    static CLOSED = 0;
    static DENIED = 1;
    static PAUSED = 2;
    static REWORK = 3;
    static WORKUP = 4;
    static FINISH = 5;
}
